"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var BrowseContactButton = function BrowseContactButton(_ref) {
  var buttonType = _ref.buttonType,
    toggle = _ref.toggle,
    text = _ref.text,
    hideIcon = _ref.hideIcon;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-left-sm btn",
    buttonType: buttonType,
    onClick: toggle
  }, !hideIcon && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "headphones",
    className: "icon--sm margin-right-xs"
  }), text);
};
BrowseContactButton.propTypes = {
  buttonType: _propTypes["default"].string,
  toggle: _propTypes["default"].func,
  text: _propTypes["default"].string,
  hideIcon: _propTypes["default"].bool
};
BrowseContactButton.defaultProps = {
  buttonType: _constants.BUTTON_TYPES.BARE
};
var _default = exports["default"] = BrowseContactButton;